import { Avatar, Chip } from "@mui/material";
import React from "react";
import { stringAvatar } from "../../../../Utils/avatar";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import LocationOnIcon from "@mui/icons-material/LocationOn";
export default function JobCard(props) {
  return (
    <div
      className="rounded-md shadow-md px-6 py-5 my-8 hover:shadow-xl cursor-pointer"
    >
      <div className="flex justify-start gap-10 items-center">
        <div className="flex gap-5 min-w-[50%]">
          {props.details?.user?.profilePhoto ? (
            <Avatar
              alt="Profile"
              src={props.details.user.profilePhoto}
              sx={{ width: 50, height: 50 }}
            />
          ) : (
            <Avatar
              {...stringAvatar(
                props.details?.user?.company ?? "ProLegion User",
                { width: 50, height: 50 }
              )}
            />
          )}
          <div className="flex flex-col">
            <span className="font-bold text-lg">{props.details?.name}</span>
            <span className="text-base inline-flex items-center">
              {props?.details?.user?.company}
            </span>
          </div>
        </div>
        <span>
          <LocationOnIcon color="primary" />
          &nbsp;&nbsp;
          {props.details.location === "REMOTE"
            ? "Remote"
            : `${props.details?.city}, ${props.details?.state}, ${props.details?.country}`}
        </span>
        <br />
        <span>
          <FiberManualRecordIcon color="success" fontSize="10" />
          &nbsp;&nbsp;
          {props.details.status === "OPEN"
            ? "Open"
            : props.details.status === "HOLD"
            ? "Hold"
            : props.details.status === "ONGOING"
            ? "Ongoing"
            : props.details.status === "CLOSED"
            ? "Closed"
            : ""}
        </span>
      </div>
      {props.details?.main_skill && (
        <div className="flex flex-row flex-wrap gap-4 py-4">
          {props.details?.main_skill?.map((skill) => {
            return <Chip label={skill} variant="outlined" clickable />;
          })}
        </div>
      )}
      <p className="py-3">
        {props.details?.description.length > 500
          ? props.details?.description.substring(0, 300) + "..."
          : props.details?.description}
      </p>
    </div>
  );
}
